import styled from '@emotion/styled';

export default styled('div')`
  box-sizing: border-box;
  padding-left: 40px;
  padding-right: 40px;
`;
